(function () {
  // =========================
  // Helpers: cookies / utm / sheets
  // =========================
  function setCookie(name, value, minutes) {
    let expires = "";
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
  }

  function generateUniqueAlphaNumericCode(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return code;
  }

  function hasTrackingParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    const adsParams = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid']; 
      return [...utmParams, ...adsParams].some(param => urlParams.has(param));
  }

  function getOrCreatePromoData() {
    let savedUrl, savedID;

    if (hasTrackingParameters()) {
      const uniqueID = "CRT" + generateUniqueAlphaNumericCode(4);
      const currentUrl = window.location.href;

      setCookie("urlWithUTM", currentUrl, 60); // minutos
      setCookie("uniqueID", uniqueID, 60);

      savedUrl = currentUrl;
      savedID = uniqueID;
    } else {
      savedUrl = getCookie("urlWithUTM");
      savedID = getCookie("uniqueID");
    }

    return { savedUrl, savedID };
  }

  function sendDataToGoogleSheets(data) {
    fetch(
      "https://script.google.com/macros/s/AKfycbyYlWE5S5EdLFRF6cgQy-wsJvjMQ-2QCQkwFGX4zEhmXJYsqA7kIHcSzw9vLkCM972Wrw/exec",
      {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
  }

  function buildWhatsAppUrl(baseHref, phone, message) {
    const base = baseHref && baseHref.includes("whatsapp")
      ? baseHref
      : "https://api.whatsapp.com/send";

    const u = new URL(base, window.location.origin);

    // Normaliza endpoint
    u.hostname = "api.whatsapp.com";
    u.pathname = "/send";

    // Phone obligatorio
    u.searchParams.set("phone", phone);

    // ✅ FORZA un solo text (elimina duplicados)
    u.searchParams.set("text", message);

    // Opcionales
    u.searchParams.set("type", "phone_number");
    u.searchParams.set("app_absent", "0");

    return u.toString();
  }

function makeMessage(savedUrl, savedID) {
  const cleanURL = window.location.origin + window.location.pathname;

  if (savedUrl && savedID) {
    return `Promoción ${savedID} ¡Hola! Coriat, tengo una duda, me puedes ayudar con el siguiente producto: ${cleanURL}`;
  }

  return `¡Hola! Coriat, tengo una duda, me puedes ayudar con el siguiente producto: ${cleanURL}`;
}

  function isWhatsAppAnchor(a) {
  const href = (a.getAttribute("href") || "").toLowerCase();
  const text = (a.textContent || "").toLowerCase();
  const id = (a.id || "").toLowerCase();

  const allowedIds = ["botonwh", "bhws"];

  return (
    allowedIds.includes(id) ||
    text.includes("whatsapp") ||
    href.includes("whatsapp") ||
    href.includes("wa.me")
  );
}


  // =========================
  // Popup lógica (salida + inactividad)
  // =========================
  let popupShown = false;
  let inactivityTimer;

  function showPopup() {
    const popup = document.getElementById("popupWhatsApp");
    if (!popup) return;

    if (!popupShown) {
      popup.classList.add("show");
      popupShown = true;

      setTimeout(() => {
        popup.classList.remove("show");
        popupShown = false;
      }, 15000);
    }
  }

  document.addEventListener("mouseleave", (e) => {
    if (!popupShown && window.innerWidth > 768 && e.clientY < 10) showPopup();
  });

  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      if (!popupShown) showPopup();
    }, 30000);
  }

  ["mousemove", "keydown", "scroll", "touchstart"].forEach((evt) => {
    document.addEventListener(evt, resetInactivityTimer, { passive: true });
  });

  resetInactivityTimer();

  // =========================
  // Inicialización DOM
  // =========================
  function init() {
    const phone = "5213332454402"; // MX recomendado: 52 + 1 + 10 dígitos
    const { savedUrl, savedID } = getOrCreatePromoData();
    const message = makeMessage(savedUrl, savedID);

    // 1) Link del popup (si existe)
    const waDynamic = document.getElementById("whatsapp-dynamic");
    if (waDynamic) {
      waDynamic.href = buildWhatsAppUrl(waDynamic.getAttribute("href"), phone, message);
      waDynamic.setAttribute("target", "_blank");
      waDynamic.setAttribute("rel", "noopener");
    }

    // 2) Cualquier link WhatsApp del sitio (header/footer/menú)
    document.querySelectorAll("a").forEach((a) => {
      if (!isWhatsAppAnchor(a)) return;

      // Actualiza href para que SIEMPRE use nuestro mensaje (sin text duplicado)
      a.href = buildWhatsAppUrl(a.getAttribute("href"), phone, message);

      // Tracking + limpieza al click (sin romper navegación)
      a.addEventListener("click", function () {
        const finalURL = window.location.href;
        const urlWithUTM = getCookie("urlWithUTM");
        const clickID = getCookie("uniqueID") || savedID;

        if (clickID && urlWithUTM) {
          sendDataToGoogleSheets({ uniqueID: clickID, urlWithUTM: urlWithUTM, finalURL: finalURL });
        }

        deleteCookie("uniqueID");
        deleteCookie("urlWithUTM");
      }, { capture: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
